/**
 * Shared text-positioning constants for the SVG + PSD round-trip
 * paths. Centralized to prevent drift between the four importer /
 * exporter modules — a single source for the baseline-to-top
 * ratio means a change to the value (e.g. switching to a per-
 * typeface metric) updates every round-trip consistently.
 *
 * (Pre-PR review R1 — all three audits flagged the duplicated
 * `BASELINE_TO_TOP_RATIO = 0.8` constant across four files as a
 * round-trip-stability risk.)
 */

/** Ratio of baseline-to-top distance over font-size for a typical
 *  Latin glyph. Used to convert SVG / PSD baseline-y coordinates
 *  into the editor's top-left bbox-y convention, and the inverse
 *  on export. Round-trip is internally bit-stable as long as
 *  every consumer reads this same constant — diverging values
 *  would compound across import → editor → export → re-import
 *  cycles.
 *
 *  Empirical choice — actual typeface-specific values vary:
 *    Arial / Helvetica: ~0.75-0.80
 *    Times / serif fonts: ~0.68-0.75
 *    Comic Sans: ~0.75
 *    Impact / display fonts: ~0.72
 *    Monospace: ~0.78
 *
 *  Picking 0.8 makes the editor preview ~2-5px low for some
 *  serif fonts, but keeps the math symmetric and round-trip-
 *  stable. A future Tier 3 follow-up could sample real font
 *  metrics via the FontFaceSet API to produce per-typeface
 *  adjustments. */
export const BASELINE_TO_TOP_RATIO = 0.8;
